import React from 'react';

import {
  EdgesContext,
  EdgesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/EdgesContext';
import {
  FlowchartFeatures,
  FlowchartFeaturesContext,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartFeaturesContext';
import {
  HandlesContext,
  HandlesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/HandlesContext';
import {
  NodesContext,
  NodesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/NodesContext';

export interface CanvasContextProvidersProps {
  flowchartFeatures: FlowchartFeatures;
  handlesContext: HandlesContextValue;
  nodesContext: NodesContextValue;
  edgesContext: EdgesContextValue;
  children: React.ReactNode;
}

/**
 * Wraps the canvas in context providers needed for rendering the flowchart.
 */
export function CanvasContextProviders({
  flowchartFeatures,
  handlesContext,
  nodesContext,
  edgesContext,
  children,
}: CanvasContextProvidersProps): JSX.Element {
  return (
    <FlowchartFeaturesContext.Provider value={flowchartFeatures}>
      <HandlesContext.Provider value={handlesContext}>
        <NodesContext.Provider value={nodesContext}>
          <EdgesContext.Provider value={edgesContext}>{children}</EdgesContext.Provider>
        </NodesContext.Provider>
      </HandlesContext.Provider>
    </FlowchartFeaturesContext.Provider>
  );
}
